import keyMirror from 'keymirror'

export default keyMirror({
  LOAD_LOCAL_STORAGE_REQUEST: null,

  RELOAD_USER_INFO_LOCAL_STORAGE_REQUEST: null,
  RELOAD_USER_INFO_LOCAL_STORAGE_SUCCESS: null
  // RELOAD_USER_INFO_LOCAL_STORAGE_FAILURE: null
})
